import { get } from 'lodash';

let googleGeocoderService;

/**
 *  Find and return the (city, state, zip) address
 */
function getPostalAddress(results) {
    for (let i = 0; i < results.length; ++i) {
        const result = results[i];

        if (result.types[0] === 'postal_code') {
            return result;
        }
    }
}

/**
 *  Performs a reverse geocoding on the given coordinates
 *  Returns a human-readable address as a string
 */
export default function fetchAddress({ latitude, longitude }) {
    // Try to initialize the service if necessary
    if (!googleGeocoderService && get(window, 'google.maps.Geocoder')) {
        googleGeocoderService = new window.google.maps.Geocoder();
    }

    return new Promise((resolve, reject) => {
        if (!googleGeocoderService) { return reject(); }

        const location = {
            lat: latitude,
            lng: longitude,
        };
        googleGeocoderService.geocode({ location }, (results, status) => {
            if (status === 'OK' && results[0]) {
                return resolve((getPostalAddress(results) || results[0]).formatted_address);
            } else {
                return reject(status);
            }
        });
    });
}
